import React from 'react';

import { IGroupEnrollment } from '../../../../store/player/games/store';

import { ScorerPaperStyled } from './ScorerPaper.Styles';
import ScorerData from './ScorerData';

interface IProps {
  item: IGroupEnrollment;
  children?: any;
  onClick?: any;
}

export const Scorer = (props: IProps) => {
  const {
    item: {
      user: { profile, firstName, lastName }
    },
    children,
    onClick
  } = props;

  return (
    <ScorerPaperStyled onClick={onClick}>
      <ScorerData image={profile.image} firstName={firstName} lastName={lastName} />

      <div className="scorer-actions">{children}</div>
    </ScorerPaperStyled>
  );
};

export default Scorer;
